import { MoonriseDarkTheme } from "../.internal/themes/MoonriseDarkTheme";
export default MoonriseDarkTheme;
